import React from 'react';
import { useAuth } from '../auth';
import { PrivacySettings } from '../components/account/PrivacySettings';

export default function Privacy() {
  const { user } = useAuth();
  return <div className="settings-page" data-testid="privacy-page"><div className="settings-content"><PrivacySettings key={user.id} /></div></div>;
}